module.exports = __webpack_public_path__ + "img/eye.99395bac.svg";